import { reactive, watch } from 'vue';
import APIClient from '~/api/apiClient';
import { CSRFType } from '~/api/apiClient';

class CSRFManager {
  public state: { csrfToken: string | null };
  private apiClient: APIClient;
  private csrfType: CSRFType;
  private renewalInterval: NodeJS.Timeout | null = null;

  constructor(csrfType: CSRFType) {
    this.state = reactive({
      csrfToken: null
    });
    this.csrfType = csrfType;
    this.apiClient = APIClient.getInstance();
    console.log('CSRF Manager initialized with type:', this.csrfType);

    // Watching for token changes (for demo purposes, logging it here)
    watch(() => this.state.csrfToken, (newVal) => {
      console.log('CSRF Token updated:', newVal, 'Type:', this.csrfType);
    });
  }

  public async startFetchingToken(): Promise<void> {
    await this.fetchToken(); // fetch immediately once
    this.setupTokenRenewal();
  }

  // Fetch a new CSRF token
  public async fetchToken(): Promise<void> {
    try {
      const response = await this.apiClient.fetchCSRF(this.csrfType);
      if (response && response.result?.csrf_token) {
        this.state.csrfToken = response.result.csrf_token;
        console.log('CSRF Token set to:', this.state.csrfToken, 'Type:', this.csrfType);
      }
    } catch (err) {
      console.error('Error fetching CSRF token:', err);
    }
  }

  // Get the currently stored token
  public getToken(): string | null {
    return this.state.csrfToken;
  }



  public stopFetchingToken(): void {
    if (this.renewalInterval) {
      clearInterval(this.renewalInterval);
      this.renewalInterval = null;
    }
    console.log('Token fetching and renewal stopped for type:', this.csrfType);
  }

  // For automatic renewal
  private setupTokenRenewal(): void {
    if (this.renewalInterval) {
      clearInterval(this.renewalInterval);
    }
    this.renewalInterval = setInterval(async () => {
      await this.fetchToken();
    }, 9.5 * 60 * 1000);
  }
}

export default CSRFManager;
